import { computed } from "nanostores";

import { getQueryAction } from "../api";
import { createApiStore } from "./api-store";
import { $router } from "./router";

export const $queryActionContent = createApiStore(getQueryAction, {
  mapToOptions: ([queryActionId]) => ({
    path: {
      queryActionId: queryActionId || "",
    },
  }),
  params: [
    computed($router, (route) =>
      route?.route === "queryActionEdit" ? route.params.queryActionId : null,
    ),
  ],
  storeKey: "queryActionContent",
});
